import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';

const AuthLayout: React.FC = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <div className={`min-h-screen ${theme} font-mono select-none selection:bg-[#02DFC2]/30 selection:text-white`}>
            {/* FIX: Removed hardcoded bg-black to let the theme context control both background and core typography rules */}
            <div className="min-h-screen flex flex-col justify-between bg-background-light dark:bg-black text-text-primary-light dark:text-slate-400 relative transition-colors duration-300">
                {/* --- Header / Top Control Nav --- */}
                <header className="relative z-50 border-b border-border-light dark:border-[#1A1D24]/40 bg-white/60 dark:bg-[#030405]/60 backdrop-blur-md">
                    <nav className="max-w-7xl mx-auto px-6 sm:px-8">
                        <div className="flex items-center justify-between h-16">
                            
                            {/* Left-Hand Actions: Logo + Terminal Track Info */}
                            <div className="flex items-center gap-6">
                                {/* Re-implemented Logo Element on the Left Side */}
                                <Link to="/" className="flex items-center z-50">
                                    <img 
                                        src="/image/logo-2.png" 
                                        alt="ThreatInformant" 
                                        className="h-44 w-44 object-contain"
                                    />
                                </Link>


                            </div>

                            {/* Minimalist Theme Control Button on the Right Side */}
                            <button
                                onClick={toggleTheme}
                                className="p-2 border border-border-light dark:border-[#1A1D24] bg-white dark:bg-black text-text-muted-light dark:text-slate-500 hover:text-[#02DFC2] dark:hover:text-[#02DFC2] hover:border-[#02DFC2]/40 dark:hover:border-[#02DFC2]/40 rounded-lg transition-all"
                                aria-label="Toggle system visibility theme"
                            >
                                {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
                            </button>
                        </div>
                    </nav>
                </header>

                {/* --- Main Content Area: Flex Container for Centered Cards --- */}
                <main className="flex-1 flex items-center justify-center p-4 md:p-8 z-10">
                    <div className="w-full max-w-5xl">
                        <Outlet />
                    </div>
                </main>

                {/* --- Tactical Sub-Footer --- */}
                <footer className="relative z-50 border-t border-border-light dark:border-[#1A1D24]/40 bg-white/40 dark:bg-[#030405]/40 backdrop-blur-md">
                    <div className="max-w-7xl mx-auto px-6 sm:px-8 py-4">
                        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-[10px] font-bold uppercase tracking-[0.15em] text-text-muted-light dark:text-slate-600">
                            <div className="flex space-x-20 mx-36">
                                <Link to="/privacy" className="hover:text-black dark:hover:text-white transition-colors">
                                    PRIVACY_POLICY
                                </Link>
                                <Link to="/terms" className="hover:text-black dark:hover:text-white transition-colors">
                                    TERMS_OF_SERVICE
                                </Link>
                            </div>
                            <div className="mx-36">
                                <span>© 2026 THREATINFORMANT</span>
                            </div>
                        </div>
                    </div>
                </footer>

                {/* Ambient Visual Grid Background Decor */}
                <div className="absolute inset-0 z-0 bg-[linear-gradient(to_right,#00000003_1px,transparent_1px),linear-gradient(to_bottom,#00000003_1px,transparent_1px)] dark:bg-[linear-gradient(to_right,#ffffff02_1px,transparent_1px),linear-gradient(to_bottom,#ffffff02_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none"></div>
            </div>
        </div>
    );
};

export default AuthLayout;